/* eslint-disable @typescript-eslint/no-explicit-any */

const getMktoForm = (formId: string): any | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  const mkto = (window as any).MktoForms2;
  if (!mkto) {
    return null;
  }
  const numericId = parseInt(formId, 10);

  return mkto.allForms().find((f: any) => f.getId() === numericId) || null;
};

const waitForForm = (formId: string, timeoutMs = 6000): Promise<any> =>
  new Promise((resolve, reject) => {
    const found = getMktoForm(formId);
    if (found) {
      resolve(found);

      return;
    }

    const start = Date.now();
    const interval = setInterval(() => {
      const form = getMktoForm(formId);
      if (form) {
        clearInterval(interval);
        resolve(form);

        return;
      }
      if (Date.now() - start > timeoutMs) {
        clearInterval(interval);
        reject(new Error(`Marketo form ${formId} did not load within ${timeoutMs}ms`));
      }
    }, 200);
  });

export interface EnrichmentPayload {
  Email: string;
  [key: string]: string;
}

export const submitEnrichment = async (formId: string, payload: EnrichmentPayload): Promise<void> => {
  if (!formId) {
    return;
  }

  try {
    const form = await waitForForm(formId);
    form.addHiddenFields(payload);
    form.submit();
  } catch (error) {
    console.error('[FreeTrialFTUX] Failed to submit enrichment form:', error);
  }
};
